import { Image } from "@kobalte/core";
import type { JSX } from "solid-js";
import { styled } from "solid-styled-components";

export const UserIconWrapper = styled(Image.Root)<{
	activity?: number;
	borderSize?: number;
	diameter: JSX.CSSProperties["width"];
}>`
  ${({ diameter }) => `
    width:${diameter};
    height:${diameter};
  `}
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  display: block;
  flex-shrink: 0;
  & > * {
    border-radius: 50%;
    width: 100%;
    height: 100%;

    object-fit: cover;
    display: block;
  }
  ${({ theme, borderSize, activity }) =>
		activity !== undefined
			? `
		padding: ${borderSize ?? 0}px;
    ${
			activity > 0
				? `
		*{
      border: ${borderSize ? 2 : 0}px solid ${theme?.colors.foreground};
		}
    `
				: ""
		}
		background : ${activity > 0 ? "linear-gradient(rgb(31, 208, 228), rgb(255, 105, 0))" : theme?.colors.foreground};
	  `
			: ""}
`;
